import { pkceUserProfile } from "@/types/auth/pkceUserProfile";
import yaml from "js-yaml";
import { normalizePlc } from "@/utilities/localStorageUtils";

export const getStatusApiConfig = (apiEnv: string, ownerProfile: any, jobID: string, type: string, access_token: string, created_at?: any) => {
  let comMode = true;
  if (sessionStorage.getItem("copMode")) {
    comMode = false;
  }
  if (apiEnv.toLowerCase() == "dev" && !comMode) {
    apiEnv = "stg";
  }
  const envParam = apiEnv.toLowerCase() == "stg" && !comMode ? "prd" : apiEnv.toLowerCase();
  let newHost = "api.pps";
  var apiKey = "";
  if (!comMode) {
    if (envParam.toLowerCase() == "prd") {
      apiKey = process.env.NEXT_PUBLIC_JOB_STATE_PROD_KEY || "";
    } else if (envParam.toLowerCase() == "stg") {
      apiKey = process.env.NEXT_PUBLIC_JOB_STATE_STG_KEY || "";
    } else {
      apiKey = process.env.NEXT_PUBLIC_JOB_STATE_DEV_KEY || "";
    }
  } else {
    if (envParam.toLowerCase() == "prd") {
      apiKey = process.env.NEXT_PUBLIC_JOB_INFO_COMMERCIAL_PROD_KEY || "";
    } else if (envParam.toLowerCase() == "stg") {
      apiKey = process.env.NEXT_PUBLIC_JOB_INFO_COMMERCIAL_STG_KEY || "";
    } else {
      apiKey = process.env.NEXT_PUBLIC_JOB_INFO_COMMERCIAL_DEV_KEY || "";
    }
  }

  let url = `https://api.pubs-${envParam}.autodesk.com/job/state`;
  if (comMode) {
    url = `https://${newHost}-${envParam}.autodesk.com/jobs/${jobID}/${created_at}?link=true`;
  }

  var config = {
    method: comMode ? "get" : "post",
    url: url,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json",
      email: ownerProfile?.emailId
    },
    data: comMode ? null : JSON.stringify({ Environment: apiEnv, UPI: jobID, JobType: type, QueryTestLink: true })
  };

  return config;
};

export const cancelApiConfig = (env: string, jobID: string, apiEnv: string, access_token: string) => {
  var apiKey = "";
  if (apiEnv.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_CANCEL_PROD_KEY || "";
  } else if (apiEnv.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_REQUEST_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_REQUEST_DEV_KEY || "";
  }

  var config = {
    method: "post",
    url: `https://api.pubs-${apiEnv}.autodesk.com/job/cancel`,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json"
    },
    data: JSON.stringify({ Environment: env, UPI: jobID })
  };

  return config;
};

export const jobRequestApiConfig = (jobTotalInfo: any, apiEnv: string, access_token: string) => {
  const env = jobTotalInfo["JobInfo"]["Environment"];
  var apiKey = "";
  if (apiEnv.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_REQUEST_PROD_KEY || "";
  } else if (apiEnv.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_REQUEST_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_REQUEST_DEV_KEY || "";
  }

  var config = {
    method: "post",
    url: `https://api.pubs-${apiEnv}.autodesk.com/job/request`,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json"
    },
    data: JSON.stringify(jobTotalInfo)
  };

  return config;
};

export const updateJobApiConfig = (
  apiEnv: string,
  access_token: string,
  validation_status: number,
  skip_validation_reason: string,
  jobId: string,
  createdAt: number
) => {
  var apiKey = "";
  if (apiEnv.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_UPDATE_PROD_KEY || "";
  } else if (apiEnv.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_UPDATE_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_UPDATE_DEV_KEY || "";
  }

  let newHost = "api.pps";
  let apiUrl = `https://${newHost}-${apiEnv}.autodesk.com/jobs/${jobId}/${createdAt}`;
  const data = { validation_status, skip_validation_reason };

  var config = {
    method: "put",
    url: apiUrl,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json"
    },
    data: btoa(unescape(encodeURIComponent(JSON.stringify(data))))
  };

  return config;
};

export const getJobMetaDataApiConfig = (apiEnv: string, email: any, metadata: string, access_token: string, plc = "") => {
  let comMode = true;
  if (sessionStorage.getItem("copMode")) {
    comMode = false;
  }
  if (apiEnv.toLowerCase() == "dev" && !comMode) {
    apiEnv = "stg";
  }
  const envParam = apiEnv.toLowerCase() == "stg" && !comMode ? "prd" : apiEnv.toLowerCase();
  let newHost = "api.pps";
  var apiKey = "";
  if (!comMode) {
    if (envParam.toLowerCase() == "prd") {
      apiKey = process.env.NEXT_PUBLIC_JOB_METADATA_PROD_KEY || "";
    } else if (envParam.toLowerCase() == "stg") {
      apiKey = process.env.NEXT_PUBLIC_JOB_METADATA_STG_KEY || "";
    } else {
      apiKey = process.env.NEXT_PUBLIC_JOB_METADATA_DEV_KEY || "";
    }
  } else {
    if (envParam.toLowerCase() == "prd") {
      apiKey = process.env.NEXT_PUBLIC_JOB_METADATA_COMMERCIAL_PROD_KEY || "";
    } else if (envParam.toLowerCase() == "stg") {
      apiKey = process.env.NEXT_PUBLIC_JOB_METADATA_COMMERCIAL_STG_KEY || "";
    } else {
      apiKey = process.env.NEXT_PUBLIC_JOB_METADATA_COMMERCIAL_DEV_KEY || "";
    }
  }

  let url = `https://api.pubs-${envParam}.autodesk.com/jobs/metadata?metadata=${metadata}`;
  if (comMode) {
    url = `https://${newHost}-${envParam}.autodesk.com/jobs/metadata?metadata=${metadata}`;
  }
  if (plc) {
    url += `&plc=${plc}`;
  }
  if (apiEnv.toLowerCase() == "stg" && !comMode) {
    url += `&env=${apiEnv.toLowerCase()}`;
  }

  var config = {
    method: "get",
    url: url,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json",
      email: email
    }
  };

  return config;
};

export const jobListApiConfig = (
  apiEnv: string,
  table: string,
  env: string,
  access_token: string,
  jobEnv = "",
  from: any = "",
  to: any = "",
  filters: any = null,
  attributes: any = null,
  limit = 10,
  LastEvaluatedKey = null
) => {
  var apiKey = "";
  if (apiEnv.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_LIST_PROD_KEY || "";
  } else if (apiEnv.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_LIST_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_LIST_DEV_KEY || "";
  }

  var data = {
    Table: table,
    Limit: limit
  };

  if (jobEnv) {
    Object.assign(data, { Environment: jobEnv });
  }
  if (from && from != "0") {
    Object.assign(data, { From: from });
  }
  if (to && to != "0") {
    Object.assign(data, { To: to });
  }
  if (filters) {
    Object.assign(data, { Filters: filters });
  }
  if (attributes && Object.keys(attributes).length) {
    Object.assign(data, { Attributes: attributes });
  }

  if (LastEvaluatedKey) {
    Object.assign(data, { LastEvaluatedKey: LastEvaluatedKey });
  }

  var config = {
    method: "post",
    url: `https://api.pubs-${apiEnv}.autodesk.com/job/list`,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json"
    },
    data: JSON.stringify(data)
  };

  return config;
};

const getJobListApiKeyByEnv = (apiEnv: string, comMode: boolean) => {
  var apiKey = "";
  if (!comMode) {
    if (apiEnv.toLowerCase() == "prd") {
      apiKey = process.env.NEXT_PUBLIC_JOB_LIST_PROD_KEY || "";
    } else if (apiEnv.toLowerCase() == "stg") {
      apiKey = process.env.NEXT_PUBLIC_JOB_LIST_STG_KEY || "";
    } else {
      apiKey = process.env.NEXT_PUBLIC_JOB_LIST_DEV_KEY || "";
    }
  } else {
    if (apiEnv.toLowerCase() == "prd") {
      apiKey = process.env.NEXT_PUBLIC_JOB_LIST_COMMERCIAL_PROD_KEY || "";
    } else if (apiEnv.toLowerCase() == "stg") {
      apiKey = process.env.NEXT_PUBLIC_JOB_LIST_COMMERCIAL_STG_KEY || "";
    } else {
      apiKey = process.env.NEXT_PUBLIC_JOB_LIST_COMMERCIAL_DEV_KEY || "";
    }
  }

  return apiKey;
};

export const jobListConfig = (
  apiEnv: string,
  ownerProfile: any,
  userProfile: any,
  access_token: string,
  job_status: any[] = [],
  type: any[] = [],
  dryRun: any = null,
  publisher: any[] = [],
  display_name = "",
  plc = "",
  job_id = "",
  created_at: any[] = [],
  job_fields = "",
  running_total = 0,
  total_count = 0,
  last_evaluated_key = null
) => {
  let comMode = true;
  if (sessionStorage.getItem("copMode")) {
    comMode = false;
  }
  if (apiEnv.toLowerCase() == "dev" && !comMode) {
    apiEnv = "stg";
  }
  const envParam = apiEnv.toLowerCase() == "stg" && !comMode ? "prd" : apiEnv.toLowerCase();
  var apiKey = getJobListApiKeyByEnv(envParam, comMode);
  let newHost = "api.pps";

  const params: any = {
    page_size: 50
  };
  if (!comMode) {
    Object.assign(params, { env: apiEnv.toLowerCase() });
  }
  if (job_id) {
    Object.assign(params, { job_id: job_id });
  } else {
    if (publisher.length) {
      Object.assign(params, { publisher: publisher });
    }
    if (display_name) {
      Object.assign(params, { display_name: display_name });
    }
    if (plc) {
      Object.assign(params, { plc: plc });
    }
    if (running_total) {
      Object.assign(params, { running_total: running_total });
    }
    if (total_count) {
      Object.assign(params, { total_count: total_count });
    }
    if (last_evaluated_key) {
      Object.assign(params, { last_evaluated_key: JSON.stringify(last_evaluated_key) });
    }
    if (job_fields) {
      Object.assign(params, { job_fields: job_fields });
    }
    if (created_at.length) {
      Object.assign(params, { created_at: created_at });
    }
    if (type.length) {
      Object.assign(params, { image_type: type });
    }
  }

  if (job_status.length) {
    Object.assign(params, { job_status: job_status });
  }
  if (dryRun != null) {
    Object.assign(params, { dryrun: dryRun });
  }
  if (userProfile) {
    Object.assign(params, { contact: userProfile?.emailId });
  }

  const queryString = Object.keys(params)
    .map((key) => {
      if (Array.isArray(params[key])) {
        // Join array values without []
        return params[key].map((value: any) => `${key}=${encodeURIComponent(value)}`).join("&");
      } else {
        return `${key}=${encodeURIComponent(params[key])}`;
      }
    })
    .join("&");

  let apiUrl = `https://api.pubs-${envParam}.autodesk.com/jobs?${queryString}`;
  if (comMode) {
    apiUrl = `https://${newHost}-${envParam}.autodesk.com/jobs?${queryString}`;
  }

  var config = {
    method: "get",
    url: apiUrl,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json",
      email: ownerProfile?.emailId
    }
  };

  return config;
};

export const jobCreateApiConfig = (apiEnv: string, ownerEmail: any, jobRequests: any, access_token: string, ClientVersion = "1.0") => {
  let comMode = true;
  // if (sessionStorage.getItem("copMode")) {
  comMode = true;
  // }
  if (apiEnv.toLowerCase() == "dev" && !comMode) {
    apiEnv = "stg";
  }
  const envParam = apiEnv.toLowerCase() == "stg" && !comMode ? "prd" : apiEnv.toLowerCase();
  let newHost = "api.pps";
  var apiKey = "";
  if (!comMode) {
    if (envParam.toLowerCase() == "prd") {
      apiKey = process.env.NEXT_PUBLIC_JOB_REQUEST_PROD_KEY || "";
    } else if (envParam.toLowerCase() == "stg") {
      apiKey = process.env.NEXT_PUBLIC_JOB_REQUEST_STG_KEY || "";
    } else {
      apiKey = process.env.NEXT_PUBLIC_JOB_REQUEST_DEV_KEY || "";
    }
  } else {
    if (envParam.toLowerCase() == "prd") {
      apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_PROD_KEY || "";
    } else if (envParam.toLowerCase() == "stg") {
      apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_STG_KEY || "";
    } else {
      apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_DEV_KEY || "";
    }
  }

  let apiUrl = `https://api.pubs-${envParam}.autodesk.com/job/request`;
  if (comMode) {
    apiUrl = `https://${newHost}-${envParam}.autodesk.com/jobs`;
  }

  // const timeStamp = new Date().getTime();

  // const jobTotalInfo = {
  //   jobRequests: jobRequests,
  //   ClientVersion: ClientVersion,
  //   Timestamp: timeStamp
  // };

  var config = {
    method: "post",
    url: apiUrl,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json",
      email: ownerEmail
    },
    data: btoa(unescape(encodeURIComponent(JSON.stringify(jobRequests))))
  };

  return config;
};

export const exportYamlFile = (data: any, dryrun: any, type: any) => {
  let comMode = true;
  if (sessionStorage.getItem("copMode")) {
    comMode = false;
  }

  const jobJsonData: any = {
    JobInfo: {
      Contact: data.contact,
      Publisher: data.publisher,
      DryRun: dryrun,
      Environment: data.environment,
      Profile: data.profile,
      Channel: data.channel,
      ChannelTag: data.channel_tag
    },
    ImageInfo: {
      PLC: normalizePlc(data.plc),
      Platform: data.platform,
      Type: data.image_type,
      Output: {
        Type: type
      }
    },
    ProductInfo: {
      DisplayName: data.display_name,
      Name: data.name,
      Country: data.country,
      Language: data.language,
      PartNumber: data.part_number ?? "",
      SAPDescription: data.sap_description ?? ""
    }
  };

  if (!(data.image_type.toLowerCase() == "product" || data.image_type.toLowerCase() == "product (major upgrade)") && type != "df") {
    jobJsonData.ImageInfo["SourceRoot"] = data.root;
  }

  if (data.component_path) {
    jobJsonData.ImageInfo["ComponentPath"] = data.component_path;
  }

  const pathParts = (data.path || "").split(";");
  if (pathParts.length > 1) {
    jobJsonData.ImageInfo["RootManifestRelativePath"] = pathParts[0];
    jobJsonData.ImageInfo["SourcePath"] = pathParts.slice(1).join(";");
  } else {
    jobJsonData.ImageInfo["SourcePath"] = data.path;
  }

  if (!data.profile) {
    delete jobJsonData.JobInfo.Profile;
  }

  if (!data.channel) {
    delete jobJsonData.JobInfo.Channel;
  }

  if (type == "df") {
    // jobJsonData.JobInfo["UPI"] = {
    //   RootUPI: data.job_id
    // };
    const downloadUrl = data.download_url;
    if (downloadUrl && downloadUrl.length > 0) {
      let downloadUrlArray = downloadUrl[0].split("https://");
      if (downloadUrlArray.length == 1) {
        downloadUrlArray = downloadUrl[0].split("http://");
      }

      let pathNameArray = downloadUrlArray[1].split("/");
      const middleElements = pathNameArray.slice(1, -1);
      let outputPath = middleElements.join("/");
      jobJsonData.ImageInfo.Output["Path"] = outputPath;
    }
  }

  if (!data.part_number || data.part_number == "") {
    delete jobJsonData.ProductInfo.PartNumber;
  }
  if (!data.sap_description || data.sap_description == "") {
    delete jobJsonData.ProductInfo.SAPDescription;
  }

  if (!comMode) {
    jobJsonData.JobInfo["Title"] = data.title;
    jobJsonData.ImageInfo["Division"] = normalizePlc(data.plc);
    jobJsonData.ImageInfo["Size"] = data.size;
  } else {
    jobJsonData.ImageInfo["Release"] = data.release;
  }

  const yamlData = yaml.dump(jobJsonData);

  let name = data.name;
  let downloadName = "";
  let existMode = false;

  const types = ["di", "db", "df", "dg", "ds", "dt"];
  for (let i = 0; i < types.length; i++) {
    if (name.toLowerCase().includes("_" + types[i])) {
      let regex = new RegExp(`_${types[i]}`, "gi");
      name = name.replace(regex, "");
    }
  }

  downloadName = `${name}_${type}.yml`;

  const blob = new Blob([yamlData], { type: "text/yaml" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = downloadName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const jobUploadFileConfig = (apiEnv: string, fileName: string, access_token: string) => {
  const envParam = apiEnv.toLowerCase();

  let newHost = "api.pps";
  var apiKey = "";
  if (envParam.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_UPLOAD_PROD_KEY || "";
  } else if (envParam.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_UPLOAD_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_UPLOAD_DEV_KEY || "";
  }

  let apiUrl = `https://${newHost}-${envParam}.autodesk.com/jobs/upload`;

  const formData = {
    UploadFiles: [fileName]
  };

  var config: any = {
    method: "post",
    url: apiUrl,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json"
    },
    data: btoa(unescape(encodeURIComponent(JSON.stringify(formData))))
  };

  return config;
};

export const jobErrorLogConfig = (apiEnv: string, jobId: string, created_at: any, logUrls: any, access_token: string) => {
  const envParam = apiEnv.toLowerCase();

  let newHost = "api.pps";
  var apiKey = "";
  if (envParam.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_ERROR_LOG_PROD_KEY || "";
  } else if (envParam.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_ERROR_LOG_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_ERROR_LOG_DEV_KEY || "";
  }

  let apiUrl = `https://${newHost}-${envParam}.autodesk.com/jobs/${jobId}/${created_at}/log`;
  const url = new URL(apiUrl);
  const params = new URLSearchParams();

  for (let i = 0; i < logUrls.length; i++) {
    params.append("log_uri", logUrls[i]);
  }
  // params.append("log_uri", logUrl);

  // Assign query parameters to the URL
  url.search = params.toString();

  var config: any = {
    method: "get",
    url: url.toString(),
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json"
    }
  };

  return config;
};

export const releaseCreateApiConfig = (apiEnv: string, jobInfo: any, access_token: string, userProfile: any) => {
  const envParam = apiEnv.toLowerCase();
  var apiKey = "";

  let newHost = "api.pps";
  if (envParam.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_RELEASE_PROD_KEY || "";
  } else if (envParam.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_RELEASE_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_RELEASE_DEV_KEY || "";
  }

  let apiUrl = `https://${newHost}-${envParam}.autodesk.com/jobs/release`;

  const data = {
    job_id: jobInfo.job_id,
    user_name: `${userProfile?.firstName} ${userProfile?.lastName}`
  };

  const config = {
    method: "post",
    url: apiUrl,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json",
      email: userProfile?.emailId
    },
    data: btoa(unescape(encodeURIComponent(JSON.stringify(data))))
  };

  return config;
};

export const releaseRetryApiConfig = (apiEnv: string, jobInfo: any, access_token: string, userProfile: any) => {
  const envParam = apiEnv.toLowerCase();
  var apiKey = "";

  let newHost = "api.pps";
  if (envParam.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_PROD_KEY || "";
  } else if (envParam.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_DEV_KEY || "";
  }

  let apiUrl = `https://${newHost}-${envParam}.autodesk.com/jobs`;

  const data = {
    JobMode: "Retry",
    JobReference: {
      Reference: [
        {
          JobId: jobInfo.job_id,
          JobType: jobInfo.type,
          DryRun: jobInfo.dryrun
        }
      ]
    }
  };

  const config = {
    method: "post",
    url: apiUrl,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json",
      email: userProfile?.emailId
    },
    data: btoa(unescape(encodeURIComponent(JSON.stringify(data))))
  };

  return config;
};

export const getJobByIdApiConfig = (apiEnv: string, jobId: any, access_token: string, userProfile: any) => {
  const envParam = apiEnv.toLowerCase();
  var apiKey = "";

  let newHost = "api.pps";
  if (envParam.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_PROD_KEY || "";
  } else if (envParam.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_DEV_KEY || "";
  }

  let apiUrl = `https://${newHost}-${envParam}.autodesk.com/jobs?page_size=1&job_id=${encodeURIComponent(jobId)}`;

  const config = {
    method: "get",
    url: apiUrl,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json",
      email: userProfile?.emailId
    }
  };

  return config;
};

export const jobRePublishApiConfig = (apiEnv: string, data: any, access_token: string, userProfile: any) => {
  const envParam = apiEnv.toLowerCase();
  var apiKey = "";

  let newHost = "api.pps";
  if (envParam.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_PROD_KEY || "";
  } else if (envParam.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_CREATE_COMMERCIAL_DEV_KEY || "";
  }

  let apiUrl = `https://${newHost}-${envParam}.autodesk.com/jobs`;

  const config = {
    method: "post",
    url: apiUrl,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json",
      email: userProfile?.emailId
    },
    data: btoa(unescape(encodeURIComponent(JSON.stringify(data))))
  };

  return config;
};

export const validateJobApiConfig = (
  apiEnv: string,
  access_token: string,
  jobId: string,
  jobType: string,
  email: string,
) => {
  var apiKey = "";
  if (apiEnv.toLowerCase() == "prd") {
    apiKey = process.env.NEXT_PUBLIC_JOB_VALIDATION_PROD_KEY || "";
  } else if (apiEnv.toLowerCase() == "stg") {
    apiKey = process.env.NEXT_PUBLIC_JOB_VALIDATION_STG_KEY || "";
  } else {
    apiKey = process.env.NEXT_PUBLIC_JOB_VALIDATION_DEV_KEY || "";
  }

  let newHost = "api.pps";
  let apiUrl = `https://${newHost}-${apiEnv}.autodesk.com/jobs/validation`;
  const data = { job_id: jobId, job_type: jobType };

  var config = {
    method: "post",
    url: apiUrl,
    headers: {
      "x-api-key": apiKey,
      "access-token": access_token,
      "Content-Type": "application/json",
      email: email
    },
    data: btoa(unescape(encodeURIComponent(JSON.stringify(data))))
  };

  return config;
};